import {CollapsedItemKeyPrefixesEnum} from '../../models/api/localPreferencesModel';

export function buildTeamWorkspaceExpandedKey(teamNamespace: string): string {
  return `${CollapsedItemKeyPrefixesEnum.WORKSPACE}${teamNamespace}`;
}
